<script lang="ts">
	interface Props {
		text: string;
		spamProtectedCall?: (() => Promise<any>) | null;
		onClick?: () => void;
	}

	let { text, spamProtectedCall = null, onClick = undefined }: Props = $props();

	let spamProtected = $state(false);
</script>

<button
	onclick={(e) => {
		onClick?.();

		if (spamProtectedCall) {
			//Prevent the call
			if (spamProtected) return;

			//Set as running
			spamProtected = true;

			//Call the callable
			spamProtectedCall()
				//Add small delay for reactivation
				.then(() => new Promise((resolve) => setTimeout(resolve, 200)))
				.finally(() => {
					//Revert the runnung flag
					spamProtected = false;
				});
		}
	}}
	class="cursor-pointer text-center text-sm"
>
	{text}
</button>

<style>
	button {
		--tw-text-opacity: 1;
		color: rgb(23 137 192 / var(--tw-text-opacity, 1));
		outline: none
}

	button:focus,
	button:hover {
		--tw-text-opacity: 1;
		color: rgb(45 218 255 / var(--tw-text-opacity, 1))
}
</style>
